export const Constants = {
  TAG_NAME: 'pop-overview-key-facts-component',
  CLASS_OVERVIEW_ASOF_DATE: '.overview-as-of-date',
  CLASS_OVERVIEW_KEYFACTS: '.overview-key-facts',
  CLASS_OVERVIEW_SECTION: '.overview-key-facts-title-section',
  NESTED_COMPONENTS: ['pop-key-fact-component'],
  OVERVIEW_TITLE_HEADER: 'h2',
} as const;
